import React, {useState} from 'react';
import {View, StyleSheet, Text, TouchableOpacity} from 'react-native';
import {BadgePrimary, Colors, disabledOpacity, Sizes, TextStyles} from '../index';
import {ComponentProps} from './ComponentProps';

interface SurfaceButtonProps extends ComponentProps {
  text: string;
  onPress: () => void;
  // gray background color if true. (by default: false)
  isInverse?: boolean;
  // dark background color if true. (by default: false)
  isActive?: boolean;
  // grays out button if false. (by default: true)
  isEnabled?: boolean;
  // restricts width to its child if true. default: true
  widthFitsChildren?: boolean;
  iconLeft?: JSX.Element;
  iconRight?: JSX.Element;
  // onPressIn event. If set, item won't highlight so caller will be responsible to
  // use isActive to simulate highlight
  onPressIn?: () => void;
  onPressOut?: () => void;
  badgeValue?: string;
}

export const SurfaceButton = (props: SurfaceButtonProps) => {
  const [isPressed, setIsPressed] = useState(false);

  const isInverse = props.isInverse ?? false;
  const isActive = props.isActive ?? false;
  const isEnabled = props.isEnabled ?? true;
  const widthFitsChildren = props.widthFitsChildren ?? true;
  let backgroundColor = isInverse ? Colors.brandWhite : Colors.neutralOff;
  let fontColor = Colors.primary;
  if (isActive || isPressed) {
    backgroundColor = Colors.primaryActive;
    fontColor = Colors.brandWhite;
  }
  let containerStyle = [props.containerStyle ?? {}, {opacity: isEnabled ? 1 : disabledOpacity}];
  let textStyle = [styles.text, TextStyles.textMediumS, {color: fontColor, flex: widthFitsChildren ? 0 : 1}];
  if (widthFitsChildren) {
    containerStyle.push(styles.constraintToWidth);
  }
  return (
    <View style={containerStyle}>
      <TouchableOpacity
        style={[styles.container, {backgroundColor: backgroundColor}]}
        activeOpacity={1}
        onPress={isEnabled ? props.onPress : undefined}
        onPressIn={
          isEnabled
            ? () => {
                if (props.onPressIn) {
                  props.onPressIn();
                } else {
                  setIsPressed(true);
                }
              }
            : undefined
        }
        onPressOut={
          isEnabled
            ? () => {
                if (props.onPressOut) {
                  props.onPressOut();
                } else {
                  setIsPressed(false);
                }
              }
            : undefined
        }
        testID={props.testID}>
        {props.iconLeft && <View style={styles.iconLeft}>{props.iconLeft}</View>}
        <Text style={textStyle}>{props.text}</Text>
        {props.iconRight && <View style={styles.iconRight}>{props.iconRight}</View>}
        {props.badgeValue && (
          <BadgePrimary text={props.badgeValue} isInverse={isActive} containerStyle={styles.iconRight} />
        )}
      </TouchableOpacity>
    </View>
  );
};

const styles = StyleSheet.create({
  constraintToWidth: {
    alignItems: 'flex-start',
  },
  unConstraintToWidth: {
    flex: 1,
  },
  container: {
    borderRadius: Sizes.s,
    padding: Sizes.s,
    flexDirection: 'row',
    alignItems: 'center',
  },
  text: {
    textAlign: 'center',
  },
  iconLeft: {
    marginRight: Sizes.s,
  },
  iconRight: {
    marginLeft: Sizes.s,
  },
});
